// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export type PdfSettingsType = {
    parameters: {
        clientName?: string;
        website?: string;
        phoneNumber?: string;
        email?: string;
        streetAddress1?: string;
        streetAddress2?: string;
        city?: string;
        province?: string;
        postalCode?: string;
        freightCharges: number;
        labourCharges: number;
        shopSupplies: number;
        priceDisplayOption?: string;
        expirationDate?: string | null;
        logoFileName?: string;
        id?: string;
        generalNote?: string;
    };
};

const initialState: PdfSettingsType = {
    parameters: {
        clientName: "",
        website: "",
        phoneNumber: "",
        email: "",
        streetAddress1: "",
        streetAddress2: "",
        city: "",
        province: "",
        postalCode: "",
        priceDisplayOption: "",
        logoFileName: "",
        expirationDate: null,
        labourCharges: 0,
        freightCharges: 0,
        shopSupplies: 0,
        generalNote: "",
    },
};

const reducer = {
    "PdfSettings/UpdatePdfSettings": (draft: Draft<PdfSettingsType>, actions: { value: typeof draft.parameters }) => {
        draft.parameters = actions.value;
    },
    "PdfSettings/ClearSettings": (draft: Draft<PdfSettingsType>) => {
        draft.parameters.clientName = initialState.parameters.clientName;
        draft.parameters.website = initialState.parameters.website;
        draft.parameters.phoneNumber = initialState.parameters.phoneNumber;
        draft.parameters.email = initialState.parameters.email;
        draft.parameters.streetAddress1 = initialState.parameters.streetAddress1;
        draft.parameters.streetAddress2 = initialState.parameters.streetAddress2;
        draft.parameters.city = initialState.parameters.city;
        draft.parameters.province = initialState.parameters.province;
        draft.parameters.postalCode = initialState.parameters.postalCode;
        draft.parameters.priceDisplayOption = initialState.parameters.priceDisplayOption;
        draft.parameters.logoFileName = initialState.parameters.logoFileName;
        draft.parameters.expirationDate = initialState.parameters.expirationDate;
        draft.parameters.labourCharges = initialState.parameters.labourCharges;
        draft.parameters.freightCharges = initialState.parameters.freightCharges;
        draft.parameters.shopSupplies = initialState.parameters.shopSupplies;
        draft.parameters.generalNote = initialState.parameters.generalNote;
    },
};

const pdfSettings = createTypedReducerWithImmer(initialState, reducer);
(reducers as any).pdfSettings = pdfSettings;

export type pdfSettingsState = {
    pdfSettings: PdfSettingsType;
} & ApplicationState;
